"use client";
import Image from "next/image";
import React, { useMemo, useState } from "react";

const DynamicImage = React.memo(function DynamicImage({
  alt,
  width,
  height,
  src,
  className,
  disableIsBlur = false,
  quality = 75,
  ...rest
}) {
  const [isLoaded, setIsLoaded] = useState(false);

  const imageStyle = useMemo(
    () =>
      !disableIsBlur
        ? {
            filter: isLoaded ? "blur(0)" : "blur(10px)",
            transition: "filter 0.1s ease-out",
          }
        : {},
    [isLoaded, disableIsBlur]
  );

  return (
    <Image
      {...rest}
      src={src || ""}
      alt={alt || "Alternative"}
      width={width}
      height={height}
      className={className}
      style={imageStyle}
      loading={src ? "eager" : "lazy"}
      onLoad={() => setIsLoaded(true)}
      quality={quality}
    />
  );
});

export default DynamicImage;
